import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 원 ")

import {computed, toRefs} from 'vue'
import {AgBoxS} from '@/components/ag'
import {currency} from '@/utils/filters'

export default /*#__PURE__*/_defineComponent({
  props: {
  endDate: {default: '', type: String},
  id: {default: '0', type: String},
  name: {default: '', type: String},
  price: {default: 0, type: Number},
},
  setup(__props) {

const props = __props



const {endDate, price} = toRefs(props)

const formattedEndDate = computed(() => {
  const date = new Date(endDate.value)
  return `${date.getFullYear()}. ${date.getMonth()}. ${date.getDate()}`
})

const maskedPrice = computed(() => {
  return currency(price.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AgBoxS), { css: {
      corner: 10,
      border: '1px solid #EEF1F7',
      bg: 'white',
      p: 16,
      dp: 'flex',
      direction: 'row',
      mb: 2,
    } }, {
    default: _withCtx(() => [
      _createVNode(_unref(AgBoxS), { css: {typography: 'main14r', mr: 4} }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.name), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), { css: {typography: 'main12r', color: 'gray3'} }, {
        default: _withCtx(() => [
          _createTextVNode(" (" + _toDisplayString(_unref(formattedEndDate)) + ") ", 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), { css: {dp: 'flex', direction: 'row', grow: 1, justifyContent: 'flex-end', alignItems: 'center'} }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), { css: {typography: 'num14eb', mr: 4} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(maskedPrice)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { css: {typography: 'main14r'} }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})